import React from 'react';
import { phoneFormatter } from '@common/helpers/phone';
import cx from 'classnames';
// when in qwik it uses qwik system because of vite config alias and in next system because of babel config, DO NOT USE ANY HOOKS IN THIS(LITE) COMPONENT
import { Link } from 'sly/system';
import { node, bool, string, any } from 'proptypes';

const HeaderAgentPhNo = ({ className, isTopBar, TooltipWrapper }) => {
  const phoneNumber = '8558667661';
  return (
    <div className={cx(!isTopBar && 'min-w-[152px]', className && className)}>
      {isTopBar && (
        <div className='font-b-s flex justify-center gap-2 border-b border-slate-lighter-90 bg-viridian-lighter-90 py-2 md:hidden'>
          Talk with a local advisor for free
          <Link className='w-max' href={'tel:+1' + phoneNumber}>
            {phoneFormatter(phoneNumber)}
          </Link>
        </div>
      )}
      {!isTopBar && (
        <div className={cx('mr-5 flex rounded', 'font-b-s py-3')}>
          <div className='flex items-center'>
            {TooltipWrapper ? (
              <TooltipWrapper>
                <Link
                  className='w-max border-b border-dashed'
                  href={'tel:+1' + phoneNumber}
                >
                  {phoneFormatter(phoneNumber)}
                </Link>
              </TooltipWrapper>
            ) : (
              <Link
                className='w-max border-b border-dashed'
                href={'tel:+1' + phoneNumber}
              >
                {phoneFormatter(phoneNumber)}
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

HeaderAgentPhNo.propTypes = {
  className: string,
  isTopBar: string,
  showHeaderAgentPhNo: bool,
  InfoIcon: node,
  TooltipWrapper: any
};
export default HeaderAgentPhNo;
